import { Outlet } from "react-router-dom";
import { Grid } from "@material-ui/core";

import { Header } from "../main/Header";
import { Bottom } from "../main/Bottom";

export const DemoLayout = () => {
  return (
    <Grid
      container
      direction="column"
      wrap="nowrap"
      justifyContent="space-between"
      style={{ height: "100vh" }}
    >
      <Grid item>
        <Header />
      </Grid>
      <Grid item style={{ flex: 1, overflowy: "auto" }}>
        <Outlet />
      </Grid>
      <Grid item>
        <Bottom demoLayout />
      </Grid>
    </Grid>
  );
};
